import { ViteReactSSG } from "vite-react-ssg";
import { routes } from "@/app/routes";
import "@/i18n";
import "@/styles/global.css";

/**
 * App entry — consumed by the `vite-react-ssg` CLI (see vite.config.ts `ssgOptions.entry`) both
 * for `npm run dev` (SSR-on-request dev server) and `npm run build` (prerender every route in
 * `routes` to static .html — see src/app/routes.tsx).
 */
export const createRoot = ViteReactSSG({ routes });
